export default __webpack_public_path__ + "static/media/qr-wokee.7f0013fd.png";